import { ProbeLot } from 'entities/probe_lot'
import { ViewModel } from 'view_models/view_model'

export class ProbeLotViewModel extends ViewModel<ProbeLot> {
    public dateText = () => {
        return this.toDateText(this.object.date)
    }
}
